import React from 'react';
import { useIntl } from 'react-intl';
import { MdOutlinePhone } from 'react-icons/md';
import IconButton from '@/components/action-button';
import { Headline } from '@ldfeplatform/componentlibrary.ui.molecules.headline';
import { Text } from '@ldfeplatform/componentlibrary.ui.atoms.text';
import { Divider } from '@ldfeplatform/componentlibrary.ui.atoms.divider';
import { Link } from '@ldfeplatform/componentlibrary.ui.atoms.link';

import { PharmaprixOwnersContentProps } from './pharmaprix-owners-content.interface';
import styles from './pharmaprix-owners-content.module.scss';

const PharmaprixOwnersContent: React.FC<PharmaprixOwnersContentProps> = ({ groupedPharmacies }) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      {Object.entries(groupedPharmacies).map(([city, pharmacies]) => (
        <div key={city} className={styles.cityGroup}>
          <Headline title={city} headlineSize={4} className={styles.city} />
          <div className={styles.storeDetailsWrapper}>
            {pharmacies.map((pharmacy, index) => (
              <div key={index} className={styles.storeDetails}>
                <div className={styles.storeTitle}>
                  <Text className={styles.pharmacist} as="h3">
                    {pharmacy.pharmacistOwner ||
                      (Array.isArray(pharmacy.pharmacistOwners)
                        ? pharmacy.pharmacistOwners.join(', ')
                        : pharmacy.pharmacistOwners) ||
                      ''}
                  </Text>
                  <Text className={styles.pharmacistOwner}>{formatMessage({ id: 'pharmacistOwner' })}</Text>
                </div>

                <div className={styles.storeInformation}>
                  <Text>{pharmacy.address.street}</Text>
                  <Text>{`${pharmacy.address.city}, ${pharmacy.address.province} ${pharmacy.address.postalCode}`}</Text>
                </div>

                <div className={styles.phoneNumber}>
                  <IconButton
                    icon={MdOutlinePhone}
                    linkUrl={`tel:${pharmacy.phoneNumber}`}
                    linkText={pharmacy.phoneNumber}
                    textDecoration="underline"
                  />
                </div>
                <Link className={styles.link} href={pharmacy.storeUrl}>
                  {formatMessage({ id: 'pharmacyDetails' })}
                </Link>
              </div>
            ))}
          </div>
          <Divider borderColor={'#CACACA'} />
        </div>
      ))}
    </div>
  );
};

export default PharmaprixOwnersContent;
